
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Search from 'vux/src/components/search/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { request, setToken } from "../utils/axios";

export default {
directives: {
TransferDom,
},
components: {
XHeader,
Actionsheet,
ButtonTab,
ButtonTabItem,
Group,
Cell,
CellFormPreview,
CellBox,
Badge,
Card,
Divider,
Tabbar,
TabbarItem,
Search,
XButton,
Scroller,
Toast,
XDialog,
typeFlag: false,
},
beforeMount() {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?reservationBy=${localStorage.getItem(
"openId"
)}&size=${this.size}`
)
.then((response) => {
this.contentData = response.data.content;
console.log(this.contentData);
})
.catch((error) => {
console.error("Error fetching data:", error);
});

request('get', '/hitf/v2p/rest/invoke/queryLovValueList?lovCode=DQ_RESERVATION_STATUS').then(res => {
this.typeList=res.data
})
},
data() {
return {
size: 10,
page: 1,
menus: {
menu1: "Take Photo",
menu2: "Choose from photos",
},
show5: false,
showMenus: false,
value: "",
contentData: [],
type: "",
pulldownConfig: {
content: "下拉刷新",
height: 40,
autoRefresh: false,
downContent: "下拉刷新",
upContent: "释放后刷新",
loadingContent: "正在刷新...",
clsPrefix: "xs-plugin-pulldown-",
},
typeList: [
{ value: "", meaning: "全部" },
{ value: "TO_APPROVE", meaning: "待审批" },
{ value: "APPROVED", meaning: "已完成" },
{ value: "CANCEL", meaning: "已取消" },
],
pullupConfig: {
content: "",
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: "释放后加载",
upContent: "上拉加载更多",
loadingContent: "加载中...",
clsPrefix: "xs-plugin-pullup-",
},
typeFlag: false,
typeMeaning:'全部'
};
},
methods: {
onSearch() {
console.log(this.value);
},
changeType(type) {
this.type = type.value;
this.typeMeaning = type.meaning;
this.handleSearch();
this.typeFlag = false;
},
handleSearch(data) {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?reservationBy=${localStorage.getItem(
"openId"
)}&vehicleCode=${this.value}&reservationDocStatus=${this.type}&size=${
this.size
}`
)
.then((response) => {
this.contentData = response.data.content;
this.$refs.scroller.reset(
{
left: 0,
top: 0,
},
300,
"ease"
);
})
.catch((error) => {
console.error("Error fetching data:", error);
});
},
onSubmit() {
console.log(this.value);
},
toDetail(item) {
this.$router.push({
path: "/reservation/detail",
query: {
reservationDocId: item.reservationDocId,
},
});
},

refresh() {
this.size = 10;
this.handleSearch(1); 

},

loadMore() {
this.size += 10;
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?reservationBy=${localStorage.getItem(
"openId"
)}&vehicleCode=${this.value}&reservationDocStatus=${this.type}&size=${
this.size
}`
)
.then((response) => {
if (this.contentData.length >= response.data.totalElements) {
this.show5 = true;
}
this.contentData = response.data.content;
this.$refs.scroller.donePulldown();
this.$refs.scroller.donePullup();
})
.catch((error) => {
console.error("Error fetching data:", error);
});
},
},
};



// WEBPACK FOOTER //
// ./src/views/appointment-record.vue